/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { accessAPI, Formulario, Sidebar, Titulo, useOrganismo } from "../../shared";

// Enviar un archivo a una actividad abierta, desde su pantalla. Panel lateral
// con el Formulario compartido, como los formularios del admin. El organismo
// recibe un aviso por mail y lo ve en el inicio del admin.
export default function EnviarArchivo({ visible, onHide, actividadId, onEnviado, toast }) {
  const organismo = useOrganismo();
  const [enviando, setEnviando] = useState(false);
  // Formulario vacío cada vez que se abre el panel
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    if (visible) setFormKey((k) => k + 1);
  }, [visible]);

  const enviar = (campos, archivo) => {
    setEnviando(true);
    accessAPI(
      "POST",
      `cliente/proceso/actividad/${actividadId}/archivo`,
      { nota: campos.nota || "" },
      () => {
        setEnviando(false);
        toast?.current?.show({
          severity: "success",
          summary: "Archivo enviado",
          detail: `${organismo === "el organismo" ? "El organismo" : organismo} ya puede verlo.`,
          life: 4000
        });
        onEnviado?.();
        onHide();
      },
      (r) => {
        setEnviando(false);
        toast?.current?.show({
          severity: "error",
          summary: "No se pudo enviar",
          detail: r?.[0]?.msg || "Intenta nuevamente más tarde.",
          sticky: true
        });
      },
      archivo
    );
  };

  const config = {
    secciones: [
      {
        campos: [
          { nombre: "archivo", tipoitemformularioid: 10, etiqueta: "Archivo", requerido: true },
          { nombre: "nota", tipoitemformularioid: 11, etiqueta: "Nota" }
        ]
      }
    ],
    botones: [{ etiqueta: "Enviar archivo", callback: enviar, validar: true }]
  };

  return (
    <Sidebar visible={visible} onHide={onHide} position="right" className="w-full lg:w-30rem md:w-30rem">
      <Titulo>Enviar archivo</Titulo>
      <Formulario key={formKey} config={config} loader={enviando} />
    </Sidebar>
  );
}
